const PictureIcon = () => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3929 0.817993H0.607143C0.271317 
        0.817993 0 1.08931 0 1.42514V13.568C0 13.9038 
        0.271317 14.1751 0.607143 14.1751H16.3929C16.7287 
        14.1751 17 13.9038 17 13.568V1.42514C17 1.08931 16.7287 
        0.817993 16.3929 0.817993ZM15.6339 12.8091H1.36607V12.052L3.99386 
        8.93473L6.84174 12.312L11.272 7.06018L15.6339 12.2323V12.8091ZM15.6339 
        10.3463L11.3877 5.31085C11.327 5.23875 11.217 5.23875 11.1562 
        5.31085L6.84174 10.426L4.1096 7.1873C4.04888 7.1152 3.93884 7.1152 
        3.87812 7.1873L1.36607 10.1661V2.18406H15.6339V10.3463ZM4.55357 
        6.43406C4.77283 6.43406 4.98995 6.39088 5.19252 6.30697C5.39509 
        6.22306 5.57915 6.10008 5.73419 5.94504C5.88923 5.79 6.01221 
        5.60594 6.09612 5.40337C6.18003 5.2008 6.22321 4.98368 6.22321 
        4.76442C6.22321 4.54516 6.18003 4.32805 6.09612 4.12548C6.01221 
        3.92291 5.88923 3.73885 5.73419 3.58381C5.57915 3.42877 5.39509 
        3.30578 5.19252 3.22187C4.98995 3.13797 4.77283 3.09478 4.55357 
        3.09478C4.11075 3.09478 3.68607 3.27069 3.37296 3.58381C3.05984 
        3.89692 2.88393 4.3216 2.88393 4.76442C2.88393 5.20724 3.05984 
        5.63192 3.37296 5.94504C3.68607 6.25816 4.11075 6.43406 4.55357 
        6.43406ZM4.55357 4.23317C4.84766 4.23317 5.08482 4.47034 5.08482 
        4.76442C5.08482 5.05851 4.84766 5.29567 4.55357 5.29567C4.25949 
        5.29567 4.02232 5.05851 4.02232 4.76442C4.02232 4.47034 4.25949 
        4.23317 4.55357 4.23317Z"
      // fill="#5B88BD"
    />
  </svg>
);
export default PictureIcon;
